import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconReport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.625 11.3125C9.68333 12.5809 8.19524 13.4707 6.5 13.5C3.75 13.5 1.5 11.25 1.5 8.5C1.5 5.75 3.75 3.5 6.5 3.5M13.1875 12.5C14 11.2553 14.5 9.75532 14.5 8.15957C14.5 3.91489 11.1562 0.5 7 0.5V8.15957L13.1875 12.5Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconReport;
